import { takeEvery } from 'redux-saga/effects';
import { fetchVideoEffect } from './effects/fetch-video';
import { fetchHomeVideoEffect } from './effects/fetch-home-video';
import { VIDEO_BOX_HOME_REQUEST, VIDEO_BOX_REQUEST } from './actions';

export const videoBoxSaga = function* () {
  yield takeEvery(VIDEO_BOX_REQUEST, fetchVideoEffect);
  yield takeEvery(VIDEO_BOX_HOME_REQUEST, fetchHomeVideoEffect);
};
